import { ReactComponent as ArrowRight } from "../../assets/icons/arrow-right.svg";
import Button from "./Button";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Bullet from "./Bullet";

const PlayButtonContainer = styled.div`
  display: flex;
  align-items: center;
  background: #f2cdce;
  border-radius: 12px;
  padding: 3px 12px;
  padding-left: 2px !important;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 4px;

  :hover {
    background: #f2cdce80;
    ${Bullet} {
      background-color: #ccc;
    }
  }
`;

export default ({ children = [], onClick }: any) => {
  const { t } = useTranslation("games");
  return (
    <PlayButtonContainer onClick={onClick}>
      <Button active={true}>
        <ArrowRight />
      </Button>
      {children.length ? <>{children}</> : t("start")}
    </PlayButtonContainer>
  );
};
